import { render, staticRenderFns } from "./authorIndex.vue?vue&type=template&id=bec76852&scoped=true&"
import script from "./authorIndex.vue?vue&type=script&lang=js&"
export * from "./authorIndex.vue?vue&type=script&lang=js&"
import style0 from "./authorIndex.vue?vue&type=style&index=0&id=bec76852&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec76852",
  null
  
)

export default component.exports